import Image from "next/image";
import styles from "./ulcer-management-lang.module.scss";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";

export default function UlcerManagementLang() {
  return (
    <div className={`${styles["UlcerManagementLang"]}`}>
      <div className={`${styles["UlcerManagementLangContainer"]}`}>
        <div className={`${styles["UlcerManagementLangMiddle"]}`}>
          <div className={`${styles["UlcerManagementLangMiddleItem"]}`}>
            <Image
              src="/images/ulcer-management-country/logo-global-pharma.png"
              alt="globalpharma"
              width={270}
              height={40}
              className={`${styles["UlcerManagementLangMiddleItemMainImage"]}`}
            />
            <a href="/en/globalpharma-emilok20/" rel="noopener">
              <ArrowCircleLeftOutlinedIcon />
            </a>
            <h1>Educational Content / محتوى تثقيفي</h1>

            <a
              href="https://qrhub.io/accounts/globalpharma/emilok20/emilok20-en.pdf"
              target="_blank"
              rel="noopener"
              className={`${styles["UlcerManagementLangMiddleItemPdfLink"]}`}
            >
              English
            </a>
            <a
              href="https://qrhub.io/accounts/globalpharma/emilok20/emilok20-ar.pdf"
              target="_blank"
              rel="noopener"
              className={`${styles["UlcerManagementLangMiddleItemPdfLink"]}`}
            >
              عربي
            </a>
            <a
              href="https://qrhub.io/accounts/globalpharma/emilok20/emilok20-urdu.pdf"
              target="_blank"
              rel="noopener"
              className={`${styles["UlcerManagementLangMiddleItemPdfLink"]}`}
            >
              اُردُو
            </a>
          </div>
        </div>
      </div>
      <div className={`${styles["UlcerManagementLangBottom"]}`}>
        <p>
          POWERED BY{" "}
          <a href="https://www.qrhub.io" target="_blank" rel="noopener">
            <strong>QRHUB.IO</strong>{" "}
          </a>
          AND{" "}
          <a href="https://www.effective.ae" target="_blank" rel="noopener">
            <strong>EFFECTIVE AGENCY</strong>{" "}
          </a>
          COMPANY
        </p>
      </div>
    </div>
  );
}

UlcerManagementLang.hideLayout = true;
